import styled from 'styled-components';

export const DrawSettingsCanvasWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;

  & > div {
    flex-grow: 1;
  }
`;
